import { getAttribute } from '../api/Util'

class EventProductRepository {
  /**
   * @name EventRepository#api
   * @type {Api}
   */

  /**
   * @name EventRepository#maxCustomerGroupId
   * @type {int}
   */

  /**
   * @param {Api} api
   */
  constructor (api) {
    this.api = api
  }

  setMaxCustomerGroupId (maxCustomerGroupId) {
    this.maxCustomerGroupId = maxCustomerGroupId
  }

  getProductOccurrences (regionId, startDate, endDate, excludeId) {
    let priceLists = []
    let campaigns = []
    return Promise
      .all([
        this.getPriceListsForRegion(regionId).then(records => (priceLists = records)),
        this.getCampaignsForRegion(regionId).then(records => (campaigns = records))
      ])
      .then(() => {
        priceLists = this.filterWithoutEventId(priceLists)
        priceLists = this.filterPriceListsWithId(priceLists, excludeId)
        priceLists = this.filterByDate(priceLists, startDate, endDate)
        let priceListProducts = this.getProductOccurrencesInPriceLists(priceLists)

        campaigns = this.filterWithoutEventId(campaigns)
        campaigns = this.filterCampaignsWithId(campaigns, excludeId)
        campaigns = this.filterByDate(campaigns, startDate, endDate)
        let campaignProducts = this.getProductOccurrencesInCampaigns(campaigns)

        return priceListProducts.concat(campaignProducts)
      })
  }

  getPriceListsForRegion (regionId) {
    let priceListParameters = {
      searchAttributeName: 'regionId',
      searchAttributeValue: regionId
    }

    return this.api.priceLists.get(priceListParameters)
        .then(pricelists => {
          return pricelists
        })
  }

  getCampaignsForRegion (regionId) {
    let campaignParams = {
      searchAttributeName: 'regionId',
      searchAttributeValue: regionId
    }
    return this.api.campaigns.get(campaignParams)
  }

  filterPriceListsWithId (priceLists, excludeEventId) {
    return priceLists.filter(priceList => {
      if (priceList.pricelistID === excludeEventId) {
        return false
      } else if (parseInt(getAttribute(priceList, 'relatedPriceListId')) === excludeEventId) {
        return false
      } else {
        return true
      }
    })
  }

  filterCampaignsWithId (campaigns, excludeEventId) {
    return campaigns.filter(campaign => {
      if (parseInt(getAttribute(campaign, 'relatedPriceListId')) === excludeEventId) {
        return false
      } else {
        return true
      }
    })
  }

  filterWithoutEventId (items) {
    return items.filter(item => {
      return getAttribute(item, 'eventId')
    })
  }

  filterByDate (dateables, startDate, endDate) {
    return dateables.filter(dateable => {
      if (dateable.startDate === '0000-00-00') {
        dateable.startDate = null
      }
      if (dateable.endDate === '0000-00-00') {
        dateable.endDate = null
      }
      if (dateable.startDate && dateable.startDate > endDate) {
        return false
      } else if (dateable.endDate && dateable.endDate < startDate) {
        return false
      } else {
        return true
      }
    })
  }

  getProductOccurrencesInPriceLists (priceLists) {
    return priceLists.reduce((result, priceList) => {
      return result.concat(priceList.pricelistRules.map(rule => {
        return {
          customerGroupId: priceList.customerGroupId ? priceList.customerGroupId : 0,
          startDate: priceList.startDate,
          endDate: priceList.endDate,
          id: rule.id,
          eventCode: getAttribute(priceList, 'eventId')
        }
      }))
    }, [])
  }

  getProductOccurrencesInCampaigns (campaigns) {
    return campaigns.reduce((result, campaign) => {
      let customerGroupId = 0
      if (campaign.customerGroups[0]) {
        customerGroupId = campaign.customerGroups[0].id
      }
      if (campaign.awardedProducts.length) {
        return result.concat(campaign.awardedProducts.map(product => {
          return {
            customerGroupId: customerGroupId,
            startDate: campaign.startDate,
            endDate: campaign.endDate,
            id: product.productID,
            eventCode: getAttribute(campaign, 'eventId')
          }
        }))
      } else {
        return result.concat(campaign.purchasedProducts.map(product => {
          return {
            customerGroupId: customerGroupId,
            startDate: campaign.startDate,
            endDate: campaign.endDate,
            id: product.productID,
            eventCode: getAttribute(campaign, 'eventId')
          }
        }))
      }
    }, [])
  }
}

export default EventProductRepository



// WEBPACK FOOTER //
// ./src/model/EventProductRepository.js